import React, { PureComponent } from "react"
// eslint-disable-line no-unused-vars

import SvgSearch from "../_svgs/small/Search"

import "./_form-elements.scss"
import { Text } from "../../styleguide/js/components/forms"

export default class FormText extends PureComponent {
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
    this.textInput = React.createRef()
  }
  static defaultProps = {
    modifier: "",
    name: "",
    id: "formText001",
    formNotice: "",
    disabled: false,
    type: "text",
    placeholder: "",
    onChange: null,
    selected: 0,
    label: "",
    noLabel: false,
    isSearch: false,
    isInvalid: false,
    labelPositionTop: true,
    showFormNotice: false,
  }
  componentDidMount() {
    if (this.containerRef.current) new Text({ el: this.containerRef.current })
  }
  componentDidUpdate() {
    if (this.props.isInvalid) this.scrollToTextInput()
  }

  scrollToTextInput() {
    this.textInput.current.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  render() {
    return (
      <div className={this.props.modifier} ref={this.containerRef}>
        {!this.props.noLabel && this.props.labelPositionTop && (
          <label className={this.props.labelModifier} htmlFor={this.props.id}>
            {this.props.label}
          </label>
        )}
        <input
          id={this.props.id}
          className={this.props.inputModifier}
          ref={this.textInput}
          name={this.props.name}
          disabled={this.props.disabled}
          type={this.props.type}
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
        />
        {!this.props.noLabel && !this.props.labelPositionTop && (
          <label className={this.props.labelModifier} htmlFor={this.props.id}>
            <span className="form__label__text">{this.props.label}</span>
          </label>
        )}

        {this.props.isSearch && (
          <button>
            <SvgSearch />
          </button>
        )}

        {this.props.formNotice && this.props.showFormNotice && <p className="form-notice">{this.props.formNotice}</p>}
      </div>
    )
  }
}
